import RequestPromises from "@/mixins/requestPromises";
import { Component } from "vue-property-decorator";

@Component
export default class ExternalStoreMixin extends RequestPromises {
  // Data
  public isSuccess = false;
  public isAborted = false;
  public showPendingPaymentQueryParam: boolean | null = null;
  public paymentDetailIdFromExternalStore = "";

  // Methods
  public redirectToExternalStore({ approval_url, returnRoute = {} }) {
    const resolved = this.$router.resolve({
      ...returnRoute,
      query: {
        store_success: "-1",
        payment_details_id: ""
      }
    });

    window.history.pushState(
      "",
      "",
      `${location.origin}${resolved.route.fullPath}`
    );
    location.href = approval_url;
  }

  public async checkExternalStoreQueryParams({ showMessage = true } = {}) {
    const query = this.$route.query;

    if (
      !this.$_.has(query, "store_success") ||
      !this.$_.has(query, "payment_details_id")
    )
      return;

    try {
      this.isSuccess = query["store_success"] === "1";
      this.isAborted = query["store_success"] === "-1";
      this.showPendingPaymentQueryParam = false;

      this.paymentDetailIdFromExternalStore = query[
        "payment_details_id"
      ] as string;
    } catch {
      // Mask error
    }

    // Show message
    if (showMessage && !this.isAborted) {
      if (this.isSuccess) this.onExternalStoreSuccess();
      else this.onExternalStoreFail();
    } else if (this.isAborted) this.onExternalStoreAborted();

    // Remove query params
    this.removeQueryParams(["store_success", "payment_details_id"]);
  }

  public removeQueryParams(params) {
    this.$router
      .replace({
        query: this.$_.omit(this.$route.query, params)
      })
      .catch(() => {
        /** Mask error */
      });
  }

  public onExternalStoreSuccess() {
    this.$buefy.snackbar.open({
      message: this.$t("_sentence.payments.add_method_success") as string,
      actionText: this.$t("_action.dismiss") as string,
      type: "is-success"
    });
  }

  public onExternalStoreFail() {
    this.$buefy.snackbar.open({
      message: this.$t("_sentence.payments.add_method_failed") as string,
      actionText: this.$t("_action.dismiss") as string,
      type: "is-danger",
      indefinite: true
    });
  }

  public onExternalStoreAborted() {
    this.$buefy.snackbar.open({
      message: this.$t("_sentence.payments.add_method_aborted") as string,
      actionText: this.$t("_action.dismiss") as string,
      type: "is-warning"
    });
  }
}
